import { Injectable } from '@angular/core';
import { Action, Selector, State, StateContext } from '@ngxs/store';
import { HideLoader, LoaderStateModel, ShowLoader } from './loading-bar.action';

@State<LoaderStateModel>({
  name: 'loader',
  defaults: {
    status: false
  }
})
@Injectable()
export class LoadingBarState {
  @Selector()
  static status(state: LoaderStateModel): boolean {
    return state.status;
  }

  @Action(ShowLoader)
  showLoader(ctx: StateContext<LoaderStateModel>) {
    ctx.patchState({status: true});
  }

  @Action(HideLoader)
  hideLoader(ctx: StateContext<LoaderStateModel>) {
    ctx.patchState({status: false});
  }
}
